// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import {EngineDealer, CountryData, Listing, Country } from './types';


export interface ActionGetEngineDealerAPI extends Action {
    idengine?: string
    iddealer?: string    
}


export const getEngineDealerAPI = (idengine:string, iddealer?: string): ActionGetEngineDealerAPI => ({
    type: ACTIONS.GET_ENGINEDATA_API_REQUEST,
    idengine,
    iddealer
});


export interface ActionGetEngineDealerAPISuccess extends Action {
    enginedealer: EngineDealer
}

export const getEngineDealerAPISuccess = (enginedealer: EngineDealer): ActionGetEngineDealerAPISuccess => ({
    type: ACTIONS.GET_ENGINEDATA_API_SUCCESS,
    enginedealer
});

export const getEngineDealerAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_ENGINEDATA_API_ERROR,
    error
});




export interface ActionGetLastSyncDateAPI extends Action {
    iddealer?: string    
}


export const getLastSyncDateAPI = (iddealer?: string): ActionGetLastSyncDateAPI => ({
    type: ACTIONS.GET_LASTSYNCDATE_API_REQUEST,
    iddealer
});


export interface ActionGetLastSyncDateAPISuccess extends Action {
    lastsyncdate: Date
}

export const getLastSyncDateAPISuccess = (lastsyncdate: Date): ActionGetLastSyncDateAPISuccess => ({
    type: ACTIONS.GET_LASTSYNCDATE_API_SUCCESS,
    lastsyncdate
});

export const getLastSyncDateAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_LASTSYNCDATE_API_ERROR,
    error
});




export interface ActionSyncEngineDealerAPI extends Action {
    idengine?: string
    iddealer?: string  
}
export interface ActionSyncEngineDealerAPISuccess extends Action {
    listing: Listing
}

//

export const syncEngineDealerAPI = (idengine:string, iddealer?: string): ActionSyncEngineDealerAPI => ({
    type: ACTIONS.SYNC_DEALER_API_REQUEST,
    idengine,
    iddealer
});



export const syncEngineDealerAPISuccess = (listing: Listing): ActionSyncEngineDealerAPISuccess => ({
    type: ACTIONS.SYNC_DEALER_API_SUCCESS,
    listing
});

export const syncEngineDealerAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.SYNC_DEALER_API_ERROR,
    error
});



export const unsyncEngineDealerAPI = (idengine:string, iddealer?: string): ActionSyncEngineDealerAPI => ({
    type: ACTIONS.UNSYNC_DEALER_API_REQUEST,
    idengine,
    iddealer
});



export const unsyncEngineDealerAPISuccess = (listing: Listing): ActionSyncEngineDealerAPISuccess => ({
    type: ACTIONS.UNSYNC_DEALER_API_SUCCESS,
    listing
});

export const unsyncEngineDealerAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.UNSYNC_DEALER_API_ERROR,
    error
});



////Country
export interface ActionGetDealerCountryAPI extends Action {
    iddealer?: string    
}


export const getDealerCountryAPI = (iddealer?: string): ActionGetDealerCountryAPI => ({
    type: ACTIONS.GET_DEALERCOUNTRY_API_REQUEST,
    iddealer
});


export interface ActionGetDealerCountryAPISuccess extends Action {
    countryData: CountryData
}

export const getDealerCountryAPISuccess = (countryData: CountryData): ActionGetDealerCountryAPISuccess => ({
    type: ACTIONS.GET_DEALERCOUNTRY_API_SUCCESS,
    countryData
});

export const getDealerCountryAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_DEALERCOUNTRY_API_ERROR,
    error
});



////Country State
export interface ActionGetCountryStateAPI extends Action {    
}

export const getCountryStateAPI = (): ActionGetDealerCountryAPI => ({
    type: ACTIONS.GET_COUNTRYSTATE_API_REQUEST    
});

export interface ActionGetCountryStateAPISuccess extends Action {
    countries: Country[]
}

export const getCountryStateAPISuccess = (countries: Country[]): ActionGetCountryStateAPISuccess => ({
    type: ACTIONS.GET_COUNTRYSTATE_API_SUCCESS,
    countries
});

export const getCountryStateAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_COUNTRYSTATE_API_ERROR,
    error
});